import { AdmissionsCriterion, CriteriaCategory, groupCriteria } from 'components/shared/ai/AdmissionsCriteria';
import { AIJobCriterion } from 'models/AIJob';

// Group an admission job's evaluated criteria by category for the criteria drawer, ordered by the
// configured category order and then criterion order. Delegates the grouping + color validation to
// the shared `groupCriteria` (also used by the referral clinical assessment).
export function groupCriteriaByCategory(criteria: AIJobCriterion[]): CriteriaCategory[] {
  const ordered = [...criteria].sort(
    (a, b) => a.aiCriteriaSetCategory.order - b.aiCriteriaSetCategory.order || a.aiCriteria.order - b.aiCriteria.order
  );

  return groupCriteria(
    ordered.map((c) => ({
      categoryName: c.aiCriteriaSetCategory.name,
      categoryColor: c.aiCriteriaSetCategory.color,
      criterion: criterionFrom(c),
    }))
  );
}

function criterionFrom(c: AIJobCriterion): AdmissionsCriterion {
  return {
    label: c.aiCriteria.criterion,
    description: c.aiCriteria.description || undefined,
    sourceCount: c.sources.length,
    sources: c.sources.map((s) => ({ attachmentId: s.attachmentId, displayId: s.displayId })),
  };
}
